import { useRequest } from "../../../app/hooks/useRequest";
import { getJJISCodesRequest } from "../JJISRequests";

export const useGetJjisPrograms = () => useRequest(getJJISCodesRequest);
